import { do_interaction } from './Analytics_Custom';
export function selectYear({ Years }) {
    do_interaction(`DPH CDI|YEAR, ${Years.replace('ALLYEARS', 'allYrs')}`);
}
export function selectViewBy({ ViewBy }) {
    do_interaction(`DPH CDI|VIEWBY, ${ViewBy}`);
}
export function selectDataType({ DataValueTypeId }) {    
    do_interaction(`DPH CDI|DATATYPE, ${DataValueTypeId}`);
}